document.addEventListener('DOMContentLoaded', function() {
  var counter = 0;
  var counterLimit = 30;
  var barHeight = 0;

  var getBarHeight = setInterval(function() {
    if (counter > counterLimit) {
      clearInterval(getBarHeight);
    } else {
      var bar = document.querySelector('.smartbar-bar--active');

      if (bar) {
        clearInterval(getBarHeight);
        barHeight = `${bar.clientHeight}px`;
        document.querySelector('.site-header').style.top = barHeight;
        document.querySelector('.mobile-nav-panel').style.top = barHeight;
      } else {
        counter += 1;
      } 
    }
  }, 500);

  if (window.innerWidth < 720) {
    document.querySelector('.live-search-takeover-cancel').addEventListener('click', function() {
      if (!document.querySelector('live-search--takeover')) {
        document.querySelector('.live-search-form').style.removeProperty('top');
      }
    });

    document.querySelector('.live-search').addEventListener('click', function() {
      if (document.querySelector('.live-search--takeover')) {
        document.querySelector('.live-search-form').style.top = barHeight;
      }
    });
  }
});